import { SpecializedSingleSelectFilterProps } from "@components/job_search/filters/single_select_filter.tsx";

import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group.tsx";
import { SectionTitle } from "@sprout/typography.tsx";
import { Drawer, DrawerContent, DrawerTrigger } from "@components/ui/drawer.tsx";
import { useRef, useState } from "react";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import { ClearSelectionButton } from "@components/job_search/filters/clear_selection_button.tsx";
import Divider from "@sprout/divider.tsx";
import { SecondaryButton } from "@sprout/buttons";

export const MobileSingleSelectFilter = ({
  buttonText,
  name,
  options,
  value,
  onValueChange,
}: SpecializedSingleSelectFilterProps) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleValueChange = (updatedValue: string) => {
    onValueChange(updatedValue);
    setIsOpen(false);
  };

  return (
    <Drawer
      open={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
      onClose={() => triggerRef.current?.blur()}
    >
      <DrawerTrigger asChild>
        <SecondaryButton ref={triggerRef} size="medium">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <ArrowDownIcon size="sm" color="green" />
          </div>
        </SecondaryButton>
      </DrawerTrigger>
      <DrawerContent className="gap-2" onCloseAutoFocus={(e) => e.preventDefault()}>
        <SectionTitle>{name}</SectionTitle>
        <div className="text-[24px]/[1.5] text-dark-green flex flex-col gap-3 mt-3">
          <ClearSelectionButton onClear={() => handleValueChange("")} />
          <Divider />
          <RadioGroup
            value={value}
            onValueChange={handleValueChange}
            className="flex flex-col gap-2"
          >
            {options.map((option) => (
              <div key={option.value} className="flex items-center space-x-2">
                <RadioGroupItem
                  buttonSize="lg"
                  value={option.value.toString()}
                  id={option.value.toString()}
                />
                <label htmlFor={option.value.toString()} className="cursor-pointer w-full">
                  {option.label}
                </label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
